var map = {
	"./ana.png": 3629,
	"./bigana.png": 6987,
	"./bigeva.png": 7703,
	"./bigsingapore.png": 6867,
	"./eva.png": 3297,
	"./lufthansa.png": 9627,
	"./singapore.png": 7085,
	"./swiss.png": 6798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1664;